import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchVatDeclarations } from '../query-api'

export const useFetchVatDeclarations = () => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id || ''

  const { data, isLoading, isError } = useQuery(
    [QueryKeys.TaxReturnPeriods, organizationId],
    () => fetchVatDeclarations(organizationId),
    {
      enabled: !!organizationId,
    },
  )

  return {
    isError,
    isLoading,
    data: data?.salesTaxReturns,
  }
}
